import { render, staticRenderFns } from "./BaseSelectTag.vue?vue&type=template&id=77008e56&scoped=true"
import script from "./BaseSelectTag.vue?vue&type=script&lang=js"
export * from "./BaseSelectTag.vue?vue&type=script&lang=js"
import style0 from "./BaseSelectTag.vue?vue&type=style&index=0&id=77008e56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77008e56",
  null
  
)

export default component.exports